import { Button, Col, Divider, Form, Input, notification, Row, Select, Tag, Checkbox } from 'antd';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import ContainerComponent from '../../../helpers/components/container.component';
import myinvoisConfigService from '../../../services/myinvois/myinvois_config.service';
import myinvoisTransService from '../../../services/myinvois/myinvois_trans.service';
import { useHistory } from 'react-router-dom';
import globalHelper from '../../../helpers/functions/global.helper';

const RequestDocumentForm = ({ ticket, }) => {
    const history = useHistory();
    const [form] = Form.useForm();
    const buttonRef = useRef();
    const [state, setState] = useState({
        loading : false,
        submit_loading : false,

        myinvois_types : [],
        
        // set selected type
        selected_invois_type : null,
    })
    const [selectedType , setSelectedType] = useState(null);
    const [isForeigner , setIsForeigner] = useState(false);

    const type_fields = useMemo(() => {
        const selected_type = state?.myinvois_types?.find(x => x?.type_id === state?.selected_invois_type);
        const { type_fields : fields, } = selected_type ?? {};

        setSelectedType(selected_type);
        const grouped = fields?.reduce((acc, item) => {
            if(!acc[item?.section]){
                acc[item?.section] = [];
            }
            acc[item?.section]?.push(item);
            return acc;
        }, {})

        // Sort the object based on the predefined section order
        const section = ['Identification', 'Contact', 'Address'];
        const sorted_group = section?.reduce((acc, key) => {
            if (grouped?.[key]) {
                acc[key] = grouped[key];
            }
            return acc;
        }, {});

        return sorted_group ?? {};
    }, [state?.selected_invois_type])

    // submit document
    const submitDocument = async () => {
        const form_value = {...(form.getFieldsValue())};

        setState(state => ({...state, submit_loading : true, }));

        const submitDocumentResponse = await myinvoisTransService?.submitDocument({
            ticket_id : ticket?.ticket_id,
            document_type : '01',
            is_foreigner: isForeigner,
            form_value,
        })
        ?.catch(err => setState(state => ({...state, submit_loading : false, })));

        const { submit_document, errors, } = submitDocumentResponse ?? {};
        const { save_documents } = submit_document ?? {};
        
        if(errors?.length > 0){
            notification?.warning({
                description : errors?.[0],
                message : "Oops!",
            });
        }

        if(save_documents?.length > 0){
            // Redirect to success page after submitted document
            history.push(`/myinvois/document/${save_documents?.[0]?.document_id}`)
        }
        setState(state => ({...state, submit_loading : false, }));
    }

    const onSelectMyInvoisType = (type_id) => {
        setIsForeigner(false);
        form.setFieldsValue({ tin: "" }); // or restore user’s last input
        setState(state => ({ ...state, selected_invois_type: type_id, }));
    }

    const fetchMyInvoisType = async () => {
        const fetchMyInvoisTypeResponse = await myinvoisConfigService?.fetchMyInvoisTypes();

        const { myinvois_types, } = fetchMyInvoisTypeResponse;
        setState(state => ({...state, myinvois_types, }));
    }
    
    const isForeignerOnCheck = (e) => {
        const checked = e.target.checked;
        setIsForeigner(checked);
      
        if (checked) {
          form.setFieldsValue({ tin: "EI00000000020" });
        } else {
          form.setFieldsValue({ tin: "" }); // or restore user’s last input
        }
      };
      

    useEffect(() => {
        fetchMyInvoisType();
    }, [])

    return (
        <>
            <Form
            form={form}
            layout='vertical'
            onFinish={submitDocument}
            requiredMark={(label, { required, }) => {
                return (
                    <>
                        {required && <Tag color="error">Required</Tag>}
                        {label}
                    </>
                )
            }}
            >
                <div
                // className='scroll-item'
                className='mobile-padding-12 scroll-item'
                {...globalHelper?.isMobileScreen() ? { style : {}} : { style : { height : `calc(100vh - var(--header-height) - ${buttonRef?.current?.clientHeight}px)`, } }}
                >
                    <ContainerComponent span={22} top={20}>
                        <Form.Item label={"Individual/Business"} name={'id_type'}>
                            <Select
                            placeholder="Please select identification type"
                            onChange={onSelectMyInvoisType}
                            options={
                                state?.myinvois_types?.length > 0 ?
                                state?.myinvois_types?.map((type, index) => {
                                    const { name, type_id, } = type;
                                    return {
                                        value : type_id,
                                        label : name,
                                    }
                                }) :
                                []
                            }
                            />
                        </Form.Item>
                    </ContainerComponent>
                    {/* <Divider style={{ marginTop : 12, }} /> */}
                    <ContainerComponent span={22} top={20}>
                        {
                            Object.entries(type_fields)?.map(([section, fields], sectionIndex) => {
                                return (
                                    <div key={sectionIndex}>
                                        {
                                            sectionIndex != 0 && (
                                                <>
                                                    {/* <Divider style={{ marginBlock : 12, }} /> */}
                                                </>
                                            )
                                        }
                                        <div style={{ textAlign : 'start', }}>
                                            <span style={{ fontSize : 16, fontWeight : 500, color : 'var(--secondary-text-color)', }}>{section}</span>
                                        </div>
                                        <div style={{ marginTop : 6, }}>
                                            <Row gutter={[12, 0]}>
                                            {
                                                fields?.sort((a, b) => a?.sequence - b?.sequence)?.map((field, index) => {
                                                    const { label, name, placeholder, type, col = 0, is_required, enumeration, } = field ?? {};
                                                    let selections;
                                                    // safely parse the json
                                                    try {
                                                        selections = JSON.parse(enumeration);
                                                    } catch (error) {
                                                        selections = enumeration; // Fallback: Keep it as is (string or null)
                                                    }
                                                    return (
                                                        <Col xs={24} xl={col} key={index}>
                                                            <Form.Item
                                                                name={name}
                                                                label={label}
                                                                rules={[{ required: is_required }]}
                                                                style={{ marginBottom: selectedType?.is_foreigner && name === 'tin' ? 0 : 24 }}
                                                            >
                                                                {type === 'text' ? (
                                                                    <Input
                                                                        placeholder={placeholder}
                                                                        disabled={name === 'tin' && isForeigner}
                                                                    />
                                                                ) : (
                                                                    type === 'selections' && <Select options={selections} />
                                                                )}
                                                            </Form.Item>

                                                            {selectedType?.is_foreigner && name === 'tin' && (
                                                                <div style={{ textAlign: 'left', marginBottom: 24 }}>
                                                                    <Checkbox onChange={isForeignerOnCheck}>I'm a foreigner</Checkbox>
                                                                </div>
                                                            )}
                                                        </Col>
                                                    )
                                                })
                                                }
                                            </Row>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </ContainerComponent>
                </div>

                {
                    globalHelper?.isMobileScreen () ?
                    (
                        <>
                            <div style={{ paddingTop : 0, paddingBottom : 24, padding : 12, display : 'flex', width : '100%', }}>
                                <Button disabled={!state?.selected_invois_type} ref={buttonRef} loading={state?.submit_loading} onClick={() => form?.submit()} type='primary' style={{ width : 'inherit', }}>Submit Invoice</Button>
                            </div>
                        </>
                    )
                    :
                    (
                        <>
                            <div style={{ position : 'absolute', bottom : 0, padding : 24, display : 'flex', width : '100%', }}>
                                <Button disabled={!state?.selected_invois_type} ref={buttonRef} loading={state?.submit_loading} onClick={() => form?.submit()} type='primary' style={{ width : 'inherit', }}>Submit Invoice</Button>
                            </div>
                        </>
                    )
                }
            </Form>
        </>
    );
}

export default RequestDocumentForm;